import clsx from 'clsx';
import React from 'react';

type Props = {
  contentWeight?: 'normal' | 'bold';
  children?: React.ReactNode;
} & ({
  src: string;
  alt: string;
} | {
  title: string,
});

export const AboutItem: React.FC<Props> = (props) => {
  return (
    <div className='about-item'>
      <div className='about-item__logo-container'>
        {'src' in props && <img className='about-item__img' src={props.src} alt={props.alt} />}
        {'title' in props && <div className='about-item__title'>{props.title}</div>}
      </div>
      {props.children && (
        <div className={clsx('about-item__content', props.contentWeight === 'bold' && 'about-item__content_bold')}>
          {props.children}
        </div>
      )}
    </div>
  );
};